(function () {
  'use strict';

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  /**
   * Pull the size code out of an option value.
   *
   * Two shapes reach this function, confirmed against the live store:
   *   - print-type / vidrio sub-product options:  "XS"
   *   - the main product's TAMAÑO option:         "PAPEL FINE ART XS - 20 X 30 CM"
   *
   * The previous regex anchored at the start of the string, so it returned null for every
   * TAMAÑO value on the real catalogue. That silently disabled the vidrio rules and the addon
   * price lookup, both of which bail when the size is unknown. Match the code as a standalone
   * word instead, followed by a dash or the end of the string.
   */
  function extractSizeCode(val) {
    if (!val) return null;
    var m = val.match(/\b(XXL|XL|XS|S|M|L)\b(?=\s*-|\s*$)/i);
    return m ? m[1].toUpperCase() : null;
  }

  // "Papel Fine Art" and "PAPEL FINE ART XS - 20 X 30 CM" have to compare equal at the prefix.
  function normalize(s) {
    return (s || '').toUpperCase().replace(/\s+/g, ' ').trim();
  }

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return '$' + amount.toLocaleString('es-CL');
  }

  // ── State ──────────────────────────────────────────────────────────────────

  var data = null;
  var state = {
    printTypeIndex: 0,
    vidrioEnabled: false,
    currentSizeCode: null,
    currentVariantId: null,
  };

  // ── DOM references ─────────────────────────────────────────────────────────

  var variantRadiosEl = null;
  var printTypeFieldset = null;
  var vidrioFieldset = null;
  var nativePriceEl = null;
  var nativeAddToCartForm = null;
  var nativeAddToCartBtn = null;

  // ── Init ───────────────────────────────────────────────────────────────────

  function init() {
    var dataEl = document.getElementById('tca-data');
    if (!dataEl) return;

    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (!data.printTypes.length && !data.vidrio && !data.productVidrioRule) return;

    variantRadiosEl = document.querySelector('variant-radios, variant-selects');
    if (!variantRadiosEl) return;

    nativePriceEl = document.querySelector('.price-item--regular');
    nativeAddToCartForm = document.querySelector('form[action*="/cart/add"]');
    nativeAddToCartBtn = nativeAddToCartForm
      ? nativeAddToCartForm.querySelector('[type="submit"], .product-form__submit')
      : null;

    bindControls();
    listenVariantChanges();
    interceptCartSubmit();

    // Opt-in inspection hook: add ?tcadebug=1 to the product URL. Nothing is exposed otherwise,
    // so the global cannot be relied on by other code.
    if (/[?&]tcadebug=1/.test(location.search)) {
      window.__tca = {
        state: state,
        matrix: function () { return getMatrix(); },
        apply: function () { applyCompatRules(); },
        flags: function () { return { applyingRules: applyingRules, currentPrefix: currentPrefix, observer: !!skObserver }; },
      };
    }

    // Seed the size from the DOM and apply the rules once before first interaction. Without
    // this, compatibility only takes effect after the customer changes something, so the page
    // can load showing sizes the selected print type does not offer.
    readCurrentSizeFromDOM();
    syncPrintTypeToSelection();
    applyCompatRules();
    watchSwatchKing();
    updateAll();

    // Swatch King renders after us. Re-run the rules a few times over the first seconds so the
    // filter lands as soon as its dropdown exists, even if the observer above was attached
    // before the app had created anything to observe.
    var settle = 0;
    var settleTimer = setInterval(function () {
      settle++;
      watchSwatchKing();
      syncPrintTypeToSelection();
      restoreAddonSelection();
      applyCompatRules();
      if (settle >= 6) clearInterval(settleTimer);
    }, 500);
  }

  // ── Bind to the server-rendered addon controls ─────────────────────────────
  //
  // The fieldsets are rendered as part of the initial HTML by
  // snippets/testimonia-cuadro-addon-controls.liquid, placed among the native option groups
  // through custom_liquid blocks in main-product's block_order.
  //
  // They used to be created here and inserted after first paint, which caused the visible
  // layout shift roughly a second into page load. This function now only binds behaviour;
  // it never creates DOM. See docs/testimonia-pdp-contract.md §5.4.

  function bindControls() {
    printTypeFieldset = document.querySelector('[data-tca-fieldset="print"]');
    vidrioFieldset = document.querySelector('[data-tca-fieldset="vidrio"]');

    var checkedPrint = printTypeFieldset && printTypeFieldset.querySelector('input[type="radio"]:checked');
    if (checkedPrint) state.printTypeIndex = parseInt(checkedPrint.dataset.index, 10) || 0;

    var checkedVidrio = vidrioFieldset && vidrioFieldset.querySelector('input[type="radio"]:checked');
    state.vidrioEnabled = !!checkedVidrio && checkedVidrio.value === 'si';

    // Delegated on document, not bound to the individual inputs.
    //
    // These controls are server-rendered inside main-product's block list, and the theme
    // re-fetches and replaces that markup on every variant change (renderProductInfo /
    // applyProductMediaUpdate). Listeners attached to the original elements die with them, and
    // the replacements arrive with no handler — so the print type silently stopped updating
    // state.printTypeIndex and the rules kept running against the previous selection.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;

      if (t.getAttribute('name') === 'tca-print-type') {
        state.printTypeIndex = parseInt(t.dataset.index, 10) || 0;
        switchPrintType(t.value);
        applyCompatRules();
        updateAll();
      } else if (t.getAttribute('name') === 'tca-vidrio') {
        state.vidrioEnabled = t.value === 'si';
        updateAll();
      }
    });
  }

  /**
   * Re-assert the customer's addon choices after the theme replaces the markup.
   *
   * The server always renders the first print type checked and "Sin Vidrio" selected, because it
   * has no idea what the customer picked. Without this, a variant change silently reverts the
   * print type in the UI while our state still holds the real choice — the two drift apart and
   * the size filter appears to invert.
   */
  function restoreAddonSelection() {
    printTypeFieldset = document.querySelector('[data-tca-fieldset="print"]');
    vidrioFieldset = document.querySelector('[data-tca-fieldset="vidrio"]');

    if (printTypeFieldset) {
      var want = printTypeFieldset.querySelector('input[data-index="' + state.printTypeIndex + '"]');
      if (want && !want.checked) want.checked = true;
    }

    if (vidrioFieldset) {
      var value = state.vidrioEnabled ? 'si' : 'no';
      var target = vidrioFieldset.querySelector('input[value="' + value + '"]');
      if (target && !target.checked && !target.disabled) target.checked = true;
    }
  }

  // ── Option visibility ──────────────────────────────────────────────────────
  //
  // Incompatible options are hidden, not dimmed — one idiom across all three rules
  // (tamaño, paspartú, vidrio). Contract §5.8, decision D4.
  //
  // The <input> is disabled as well as hidden so it stays out of the form and the tab order;
  // `.tca-compat-hidden` only handles the visual removal (assets/testimonia-pdp.css).

  function setOptionHidden(radio, hidden) {
    if (!radio) return false;
    var label = radio.nextElementSibling;

    radio.disabled = hidden;
    radio.classList.toggle('tca-compat-hidden', hidden);
    if (label) label.classList.toggle('tca-compat-hidden', hidden);

    // Report whether this call just invalidated the current selection.
    if (hidden && radio.checked) {
      radio.checked = false;
      return true;
    }
    return false;
  }

  /**
   * A group left with a single valid option is not a choice.
   *
   * "Papel Fine Art" forces glass, so hiding "Sin Vidrio" left a radio group with exactly one
   * item — which reads as broken rather than as a decision already made. Mark the fieldset so
   * the stylesheet can drop it entirely.
   */
  // Re-select the first still-visible option in a group.
  //
  // It does NOT notify the theme any more. Every group is corrected first and a single `change`
  // is dispatched at the end of applyCompatRulesInner(), because the theme answers each event
  // with a section re-fetch: one event per group meant two or three overlapping requests whose
  // responses raced, and the last one to land won regardless of what the customer had chosen.
  function reselectFirstVisible(fieldset) {
    if (!fieldset) return;
    var first = fieldset.querySelector('input[type="radio"]:not(:disabled)');
    if (!first || first.checked) return;
    first.checked = true;
    pendingSelectionChange = true;
  }


  // ── Listen to native variant changes ───────────────────────────────────────

  function listenVariantChanges() {
    // Listen for native theme variant:change event
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant) {
        state.currentVariantId = variant.id;
        var sizeOpt = variant.options ? variant.options[2] : null;
        state.currentSizeCode = extractSizeCode(sizeOpt || variant.option3);
      }
      applyCompatRules();
      updateAll();
    });

    // Watch the hidden variant input for changes (works with Swatch King)
    var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput) {
      var inputObserver = new MutationObserver(function () {
        readCurrentSizeFromDOM();
        applyCompatRules();
        updateAll();
      });
      inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Watch price changes as a fallback signal
    if (nativePriceEl) {
      var priceObserver = new MutationObserver(function () {
        readCurrentSizeFromDOM();
        updateAll();
      });
      priceObserver.observe(nativePriceEl, { childList: true, characterData: true, subtree: true });
    }

    // Listen for clicks inside Swatch King as a change signal
    var swatchKing = document.querySelector('variant-swatch-king');
    if (swatchKing) {
      swatchKing.addEventListener('click', function () {
        setTimeout(function () {
          readCurrentSizeFromDOM();
          applyCompatRules();
          updateAll();
        }, 150);
      });
    }
  }

  function readCurrentSizeFromDOM() {
    if (!variantRadiosEl) return;
    var sizeFieldset = variantRadiosEl.querySelector('fieldset[data-option-position="3"]');
    if (!sizeFieldset) {
      var fieldsets = variantRadiosEl.querySelectorAll('fieldset.product-form__controls');
      if (fieldsets.length >= 3) sizeFieldset = fieldsets[2];
    }
    if (sizeFieldset) {
      var checked = sizeFieldset.querySelector('input:checked');
      if (checked) state.currentSizeCode = extractSizeCode(checked.value);
    }
  }

  // ── Catalogue matrix ───────────────────────────────────────────────────────
  //
  // Which option values actually co-occur with each print type, read from the variant list the
  // theme already publishes: snippets/product-variant-picker.liquid:176 emits
  // `product.variants | json` into <script data-all-variants-no-high>. Nothing is added to the
  // page, and the answer is the catalogue itself instead of a rule typed into this repo.
  //
  // The 250-variant ceiling is why this is more than a group-by. Liquid and
  // /products/<handle>.js both expose at most 250 variants; cuadro-tucanes has 412. Measured on
  // the live store, that window covers only 5 of the 12 MARCO values for Lino, so a plain
  // "never seen together" rule would delete seven perfectly valid frames.
  //
  // Truncation drops a tail of the variant ordering, and that ordering is grouped by option1.
  // So keep only the option1 groups that are fully present — their variant count equals the
  // largest group's — and trust a conclusion about an option only when every value that option
  // declares appears somewhere in that trusted sample. On cuadro-tucanes this gives
  // MARCO -> not filterable, PASPARTÚ -> filterable, Lino -> { NO }: the rule the spec sheet
  // states, derived rather than declared.

  var matrix;

  function readAllVariants() {
    var el = document.querySelector('script[data-all-variants-no-high]');
    if (!el && data && data.productId) el = document.getElementById('ProductJSON-' + data.productId);
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      if (Array.isArray(parsed)) return parsed;
      return parsed && Array.isArray(parsed.variants) ? parsed.variants : null;
    } catch (e) {
      return null;
    }
  }

  // The values each option declares, straight off the server-rendered fieldsets.
  function declaredOptionValues() {
    var out = {};
    if (!variantRadiosEl) return out;
    var fieldsets = variantRadiosEl.querySelectorAll('fieldset[data-option-position]');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var pos = parseInt(fs.dataset.optionPosition, 10);
      if (!pos) return;
      out[pos] = Array.prototype.map.call(
        fs.querySelectorAll('input[type="radio"]'),
        function (radio) { return normalize(radio.value); }
      );
    });
    return out;
  }

  // Longest match wins, so a catalogue with both "Lino" and "Lino Premium" stays unambiguous.
  function printTypeOf(value, titles) {
    var best = null;
    for (var i = 0; i < titles.length; i++) {
      if (value.indexOf(titles[i]) !== 0) continue;
      if (!best || titles[i].length > best.length) best = titles[i];
    }
    return best;
  }

  function buildMatrix() {
    var variants = readAllVariants();
    if (!variants || !variants.length) return null;

    var declared = declaredOptionValues();
    var titles = [];
    data.printTypes.forEach(function (pt) {
      var t = normalize(pt.title);
      if (t) titles.push(t);
    });
    if (!titles.length) return null;

    var rows = [];
    variants.forEach(function (v) {
      if (v.available === false) return;
      rows.push([normalize(v.option1), normalize(v.option2), normalize(v.option3)]);
    });
    if (!rows.length) return null;

    // The pivot is the option whose declared values ALL carry a print-type prefix. Testing
    // "any value matches" instead would pick PASPARTÚ, because "LINO CRUDO" and "LINO NEGRO"
    // both start with the print type "Lino".
    var pivot = -1;
    for (var pos = 1; pos <= 3; pos++) {
      var vals = declared[pos];
      if (!vals || !vals.length) continue;
      var all = vals.every(function (val) { return !!printTypeOf(val, titles); });
      if (all) { pivot = pos - 1; break; }
    }
    if (pivot < 0) return null;

    // Trusted sample: only the option1 groups the 250-variant window shows in full.
    var counts = {};
    rows.forEach(function (o) { counts[o[0]] = (counts[o[0]] || 0) + 1; });
    var full = 0;
    Object.keys(counts).forEach(function (k) { if (counts[k] > full) full = counts[k]; });
    var trusted = rows.filter(function (o) { return counts[o[0]] === full; });
    if (!trusted.length) return null;

    // An option is filterable only when the trusted sample contains every value it declares.
    var filterable = {};
    for (var p = 1; p <= 3; p++) {
      var declaredVals = declared[p];
      if (!declaredVals || !declaredVals.length || p - 1 === pivot) { filterable[p] = false; continue; }
      var seen = {};
      trusted.forEach(function (o) { seen[o[p - 1]] = true; });
      filterable[p] = declaredVals.every(function (val) { return seen[val] === true; });
    }

    var allowed = {};
    titles.forEach(function (title) {
      allowed[title] = {};
      var sub = trusted.filter(function (o) { return printTypeOf(o[pivot], titles) === title; });
      for (var q = 1; q <= 3; q++) {
        if (!filterable[q]) continue;
        var set = [];
        sub.forEach(function (o) { if (set.indexOf(o[q - 1]) === -1) set.push(o[q - 1]); });
        allowed[title][q] = set;
      }
    });

    return { pivot: pivot, filterable: filterable, allowed: allowed };
  }

  function getMatrix() {
    if (matrix === undefined) matrix = buildMatrix();
    return matrix;
  }

  /**
   * Open on the print type the current variant actually belongs to.
   *
   * snippets/testimonia-cuadro-addon-controls.liquid checks the first print type unconditionally.
   * Reloading a URL that carries a Lino variant — which is what the theme leaves in the address
   * bar after the customer picks Lino — therefore reopened the page on "Papel Fine Art", and with
   * it the PASPARTÚ group that Lino does not admit. Reported from the live store on
   * /products/cuadro-tucanes.
   *
   * The size in effect names its print type as a prefix, so read it back off the pivot option.
   * Longest match wins, for the same reason as printTypeOf().
   *
   * Runs once, at load. It must not run on every pass: when the customer picks the other print
   * type, the size still belongs to the previous one until applySizeRules moves it, and
   * re-deriving at that moment would snap the switcher straight back.
   */
  var printTypeSeeded = false;

  function syncPrintTypeToSelection() {
    if (printTypeSeeded) return;

    var m = getMatrix();
    if (!m) return;

    var fieldset = findOptionFieldset(m.pivot + 1);
    if (!fieldset) return;

    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;

    var value = normalize(checked.value);
    var best = -1;
    var bestLen = 0;
    data.printTypes.forEach(function (pt, i) {
      var title = normalize(pt.title);
      if (!title || value.indexOf(title) !== 0) return;
      if (title.length > bestLen) { bestLen = title.length; best = i; }
    });
    if (best < 0) return;

    printTypeSeeded = true;
    if (best === state.printTypeIndex) return;

    state.printTypeIndex = best;
    restoreAddonSelection();
  }

  // ── Compatibility Rules ────────────────────────────────────────────────────

  // Swatch King renders asynchronously and re-renders on selection, and our own class toggles
  // mutate the same subtree. This flag keeps the observer below from re-entering the rules while
  // they are mid-flight.
  var applyingRules = false;
  var skObserver = null;

  // Set by any rule that moved a native radio. applyCompatRulesInner() turns it into exactly one
  // `change` event, so the theme performs a single section re-fetch for the whole correction.
  var pendingSelectionChange = false;

  // Last print-type prefix applied to the size list. Kept so the observer below can restore the
  // filter after Swatch King rebuilds its dropdown, without waiting for another user action.
  var currentPrefix = null;

  function applyCompatRules() {
    if (applyingRules) return;
    applyingRules = true;
    try {
      applyCompatRulesInner();
    } finally {
      // Cleared on a macrotask so the MutationObserver microtask triggered by our own toggles
      // is still suppressed.
      setTimeout(function () { applyingRules = false; }, 0);
    }
  }

  /**
   * Re-apply the rules once Swatch King has drawn (or redrawn) its controls.
   *
   * At init() the app has not rendered its dropdown yet, so the first pass finds nothing to
   * filter. Verified on the live store: the TAMAÑO list only exists some time after our script
   * runs. Without this watcher the size filtering silently does nothing.
   */
  function watchSwatchKing() {
    // Prefer .product-parameters: it wraps both the native picker and the app's element, so a
    // full replacement of <variant-swatch-king> is still observed.
    var host = document.querySelector('.product-parameters') || document.querySelector('variant-swatch-king');
    if (!host || skObserver) return;

    var pending = null;
    skObserver = new MutationObserver(function () {
      // Swatch King rebuilds its dropdown on selection, which drops the classes we set. Restore
      // them immediately rather than waiting for the debounced pass below, otherwise the sizes
      // visibly flash back to the full list.
      //
      // Safe to run unguarded: setOptionHidden and this sync use classList.toggle with an
      // explicit boolean, so re-applying an already-correct state mutates nothing and produces
      // no further records. The loop converges instead of feeding itself.
      if (currentPrefix) syncSwatchKingSizes(currentPrefix);
      restoreCatalogueFilters();
      restoreAddonSelection();

      if (applyingRules) return;
      clearTimeout(pending);
      pending = setTimeout(function () {
        readCurrentSizeFromDOM();
        applyCompatRules();
        updateAll();
      }, 120);
    });
    skObserver.observe(host, { childList: true, subtree: true });
  }

  /**
   * Re-resolve the elements the rules write to.
   *
   * The theme answers a variant change by re-fetching the section and replacing the product
   * info block (assets/global.js:2547, renderProductInfo). Every reference captured at init()
   * would then point at a node no longer in the document, and the rules would write to detached
   * DOM while collapseSingleChoiceGroups(), which queries live, read something else.
   *
   * Precautionary rather than a fix for an observed failure: the symptom that prompted this —
   * PASPARTÚ staying collapsed after switching back to Papel Fine Art — turned out to be Chrome
   * freezing timers in a backgrounded tab, which stalled the applyingRules guard. Re-resolving
   * is still correct, and cheap enough to run on every pass.
   */
  function refreshRoots() {
    var picker = document.querySelector('variant-radios, variant-selects');
    if (picker) variantRadiosEl = picker;

    var print = document.querySelector('[data-tca-fieldset="print"]');
    if (print) printTypeFieldset = print;

    var vidrio = document.querySelector('[data-tca-fieldset="vidrio"]');
    if (vidrio) vidrioFieldset = vidrio;
  }

  function applyCompatRulesInner() {
    refreshRoots();

    // A product with a glass rule but no print types — a papiro — has nothing to filter, but the
    // glass group still has to be resolved and stated.
    if (!data.printTypes.length) {
      if (data.productVidrioRule) {
        applyVidrioRules();
        collapseSingleChoiceGroups();
        commitSelection();
      }
      return;
    }

    var pt = data.printTypes[state.printTypeIndex];
    if (!pt) return;

    // Size availability is derived from the print-type sub-product itself, so it works even
    // when no rule matrix entry exists for this print type. It must run before the vidrio
    // rules, which read state.currentSizeCode: a size invalidated by the print type has to be
    // re-selected first, or vidrio is computed against a stale size.
    restoreMarcoHiddenSizes();
    applySizeRules(pt);
    applyCatalogueRules(pt);
    // After the print type has filtered the sizes, remove the ones this marco does not come in.
    applyMarcoSizeRules();
    applyVidrioRules();
    collapseSingleChoiceGroups();

    commitSelection();
  }

  /**
   * Hand the corrected combination to the theme, once.
   *
   * This is what makes the page sellable. The rules above can move the checked radio in more
   * than one group; the theme resolves a variant by collecting ONE checked value per group and
   * asking the server for that combination (`getSelectedValuesIds`, global.js:2276), and for a
   * product past the 250-variant ceiling that request is its only route. A group left with
   * nothing checked yields `option_values=123,,456`, which the server cannot resolve, so
   * `currentVariant` comes back null and the theme calls `setUnavailable()` — the add-to-cart
   * button goes dead. That is the "no se puede comprar" on the cuadro pages.
   *
   * Guarded three ways: nothing is dispatched unless a radio actually moved; every group is
   * verified to hold a checked radio first, so a half-corrected state is never sent; and the
   * event is dispatched on a radio inside <variant-radios>, which is what onVariantChange()
   * requires (`if (!this.contains(event.target)) return`, global.js:2094).
   */
  function commitSelection() {
    if (!pendingSelectionChange) return;
    pendingSelectionChange = false;

    if (!variantRadiosEl) return;

    var groups = variantRadiosEl.querySelectorAll('fieldset[data-option-position]');
    if (!groups.length) return;

    var carrier = null;
    for (var i = 0; i < groups.length; i++) {
      var checked = groups[i].querySelector('input[type="radio"]:checked');
      if (!checked) return; // incomplete: sending it would blank the variant
      if (!carrier) carrier = checked;
    }

    if (carrier) carrier.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Restrict the TAMAÑO option to the sizes belonging to the selected print type.
   *
   * How the catalogue actually encodes this (verified on cuadro-tucanes, 250 variants):
   *   TAMAÑO values carry the print type as a prefix —
   *     "PAPEL FINE ART XS - 20 X 30 CM"
   *     "LINO XS - 20 X 30 CM"
   *   while both print sub-products expose the same six bare sizes (XS..XXL) in option2.
   *
   * So the sub-products cannot distinguish the two families; the main product's own option
   * values can. Match on the normalized print-type prefix. Contract §5.8.
   *
   * Nothing is hardcoded: the prefix comes from the print-type product title in #tca-data, so
   * renaming or adding a print type in Shopify Admin propagates on its own.
   */

  /**
   * Move the variant to the same size under the other print type. One action, then the server.
   *
   * This is the only thing the client does about sizes. It does not filter anything: the markup
   * arrives already filtered from the server (see the 'sizes' mode in
   * snippets/testimonia-cuadro-addon-controls.liquid). Pressing a print type does not change any
   * option on its own, so without this nothing moves and the page keeps the previous variant —
   * the switcher would say Lino while the price and the size stayed on Papel.
   *
   * The target radio is disabled, because the server disabled every size of the other print type.
   * It is enabled first, then checked, then one `change` is dispatched so the theme resolves the
   * variant against the server — which is what makes this work past the 250-variant ceiling.
   *
   * Then it NAVIGATES to the resolved variant. That is deliberate, and it is what makes the whole
   * design hold: the theme answers a variant change with the Section Rendering API and injects the
   * response with innerHTML, and innerHTML does not execute inline scripts, so the server's size
   * filter — emitted in the markup by the 'sizes' mode of the controls snippet — never runs on a
   * re-render. Only a real page load runs it. Reconciling that from here is precisely the
   * after-the-fact DOM mutation that raced with the app and produced "you pick Lino and the Papel
   * sizes show".
   *
   * So the print type behaves like the panel format switcher, for the same reason and with the
   * same trade: one page load, and everything on the page comes from the server already correct.
   * Contract §6.1.
   *
   * The size code is preserved, so "PAPEL FINE ART S" becomes "LINO S" and not "LINO XS".
   */
  function switchPrintType(title) {
    var prefix = normalize(title);
    if (!prefix || !variantRadiosEl) return;

    var fieldset = findOptionFieldset(3);
    if (!fieldset) return;

    var radios = fieldset.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked && normalize(checked.value).indexOf(prefix) === 0) return;

    var wanted = checked ? extractSizeCode(checked.value) : null;
    var sameCode = null;
    var firstOfType = null;

    Array.prototype.forEach.call(radios, function (radio) {
      if (normalize(radio.value).indexOf(prefix) !== 0) return;
      if (!firstOfType) firstOfType = radio;
      if (wanted && !sameCode && extractSizeCode(radio.value) === wanted) sameCode = radio;
    });

    var target = sameCode || firstOfType;
    if (!target) return;

    target.disabled = false;
    target.classList.remove('tca-compat-hidden');
    if (target.nextElementSibling) target.nextElementSibling.classList.remove('tca-compat-hidden');
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));

    // Wait for the theme to resolve the variant, then reload on it. Bounded: if it never
    // resolves, the page is left exactly as the change event made it rather than navigating
    // somewhere wrong.
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var before = input ? input.value : null;
    var waited = 0;

    var poll = setInterval(function () {
      waited += 120;
      var now = input ? input.value : null;

      if (now && now !== before) {
        clearInterval(poll);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', now);
        window.location.assign(url.toString());
        return;
      }

      if (waited >= 4000) clearInterval(poll);
    }, 120);
  }

  /**
   * The native picker is filtered by the server; this only mirrors it onto the app's control.
   *
   * The filter itself lives in the markup — see the 'sizes' mode of
   * snippets/testimonia-cuadro-addon-controls.liquid — so the theme's own inputs arrive correct
   * and nothing here decides anything.
   *
   * Swatch King still has to be told, and it does have to be told: it does NOT build its lists by
   * reading the native picker. Measured on the live store — the server disabled six of the twelve
   * size inputs before the app's script ran, and the app rendered all twelve anyway. It builds
   * from its own `window.vskData` payload, which nothing in this theme can reach.
   *
   * What makes this stable now, where the old version raced: a print-type change navigates
   * (switchPrintType), so this runs once against markup the server already made correct, instead
   * of continuously reconciling a block the theme keeps re-injecting.
   */
  function applySizeRules(pt) {
    readCurrentSizeFromDOM();

    var prefix = normalize(pt.title);
    if (prefix) syncSwatchKingSizes(prefix);
  }

  /**
   * Click the first size in Swatch King's dropdown that belongs to `prefix`.
   * Returns true when a click was issued.
   */
  function selectSwatchKingSize(prefix) {
    var sk = document.querySelector('variant-swatch-king');
    if (!sk) return false;

    var items = sk.querySelectorAll('.swatch-drop-down-list > li');
    for (var i = 0; i < items.length; i++) {
      var text = items[i].textContent;
      if (!extractSizeCode(text)) continue;
      if (normalize(text).indexOf(prefix) !== 0) continue;

      var clickable = items[i].querySelector('a, button, [role="option"], span') || items[i];
      clickable.click();
      return true;
    }
    return false;
  }

  /**
   * Mirror the size filtering onto the Swatch King control.
   *
   * Swatch King sets `display: none` on <variant-radios> and renders its own UI, so hiding the
   * native <input> alone changes nothing the customer can see. TAMAÑO renders as the app's
   * custom dropdown: ul.swatch-drop-down-list > li, each li's text being the option value.
   *
   * This couples us to the app's internal markup, which the app can change without any diff in
   * this repo — see docs/testimonia-pdp-contract.md §6. It degrades safely: if the selectors
   * stop matching, the native filtering above still holds and the page keeps working.
   */

  /**
   * Fall back to the theme's own size control when the app's list is wrong.
   *
   * Swatch King builds its lists from /products/<handle>.js, which Shopify caps at 250 variants.
   * A cuadro has up to 720. Measured on cuadro-palmera-antigua-i: with Bambú Natural selected the
   * app rebuilt TAMAÑO with six entries, all of them PAPEL FINE ART, because the Lino sizes for
   * that marco fall past the cap. Switching to Lino then left the customer looking at six Papel
   * sizes while the form held a Lino variant.
   *
   * Nothing this theme does can give the app more variants — its `ssr-seed-main-product` snippet
   * comes back empty and its product data source is the storefront endpoint. What the theme does
   * have is its own picker, rendered by Liquid with every size the product declares and already
   * filtered correctly by applySizeRules(). So when the two disagree, show that one instead.
   *
   * Scoped to the size group only: MARCO and PASPARTÚ keep the app's controls, which are correct
   * and are what the swatch images are for.
   */
  function revealNativeSizeGroup(on, skGroup) {
    if (!variantRadiosEl) return;

    var sizeFieldset = findOptionFieldset(3);
    if (!sizeFieldset) return;

    variantRadiosEl.classList.toggle('tca-native-size', on);
    sizeFieldset.classList.toggle('tca-native-size-group', on);
    if (skGroup) skGroup.classList.toggle('tca-swatch-group-hidden', on);
  }

  // True when the app offers no size for the print type in effect but the theme's own picker
  // does — i.e. the app's list is missing values that exist.
  function skSizeListIsStale(entries, prefix) {
    var appHasPrefix = entries.some(function (e) { return normalize(e.value).indexOf(prefix) === 0; });
    if (appHasPrefix) return false;

    var sizeFieldset = findOptionFieldset(3);
    if (!sizeFieldset) return false;

    return Array.prototype.some.call(
      sizeFieldset.querySelectorAll('input[type="radio"]'),
      function (radio) { return normalize(radio.value).indexOf(prefix) === 0; }
    );
  }

  function syncSwatchKingSizes(prefix) {
    if (prefix) currentPrefix = prefix;

    var sk = document.querySelector('variant-swatch-king');
    if (!sk) return;

    var groups = sk.querySelectorAll('.swatch-single');
    for (var g = 0; g < groups.length; g++) {
      var entries = swatchGroupEntries(groups[g]);
      if (!entries.length) continue;

      // Only touch the group whose entries look like sizes.
      var looksLikeSizes = false;
      for (var i = 0; i < entries.length; i++) {
        if (extractSizeCode(entries[i].value)) { looksLikeSizes = true; break; }
      }
      if (!looksLikeSizes) continue;

      // Two different reasons the app can carry no entry for this prefix, and they need
      // opposite answers:
      //
      //   the product does not encode the print type in its size values  -> show everything
      //   the app's list is truncated and is missing them                -> show the theme's own
      //
      // skSizeListIsStale() tells them apart by asking whether the native picker has values the
      // app does not.
      if (skSizeListIsStale(entries, prefix)) {
        revealNativeSizeGroup(true, groups[g]);
        continue;
      }
      revealNativeSizeGroup(false, groups[g]);

      var anyPrefixed = false;
      for (var p = 0; p < entries.length; p++) {
        if (normalize(entries[p].value).indexOf(prefix) === 0) { anyPrefixed = true; break; }
      }

      for (var j = 0; j < entries.length; j++) {
        var hide = anyPrefixed && normalize(entries[j].value).indexOf(prefix) !== 0;
        entries[j].el.classList.toggle('tca-compat-hidden', hide);
        if (entries[j].item) entries[j].item.classList.toggle('tca-compat-hidden', hide);
      }
    }
  }

  /**
   * The entries of a Swatch King group, whichever shape it drew.
   *
   * The app renders an option either as `ul.swatch-drop-down-list > li` or as a stack of
   * `[data-value]` swatches, and which one it picks is a per-option setting in the app, not
   * something this theme controls. Reading only the dropdown meant that on any product whose
   * TAMAÑO was configured as swatches the size filter never reached the control the customer
   * actually sees: the native inputs were filtered correctly underneath while the visible list
   * still offered every size of both print families.
   */
  function swatchGroupEntries(group) {
    var out = [];

    var dropdown = group.querySelectorAll('.swatch-drop-down-list > li');
    if (dropdown.length) {
      Array.prototype.forEach.call(dropdown, function (li) {
        out.push({ el: li, item: null, value: li.textContent });
      });
      return out;
    }

    Array.prototype.forEach.call(group.querySelectorAll('[data-value]'), function (el) {
      out.push({ el: el, item: el.closest('li'), value: el.dataset.value });
    });
    return out;
  }

  /**
   * Restrict every filterable option to the values the catalogue actually pairs with the
   * selected print type.
   *
   * This replaces the hand-written matrix that used to live in
   * sections/testimonia-cuadro-addons.liquid as
   *   { "Papel Fine Art": { "paspartu": null }, "Lino": { "paspartu": ["NO"] } }
   * together with a comment claiming the rule had no counterpart in the data. It does: across
   * the 215.132 variants of the store, no published product pairs a Lino size with a paspartú
   * other than "NO". See buildMatrix() for how the 250-variant ceiling is handled, and
   * docs/testimonia-pdp-contract.md §5.8.
   *
   * The option positions are not named here. Whichever option the catalogue constrains gets
   * constrained; the pivot (the one carrying the print type in its values) is left to
   * applySizeRules.
   */
  function applyCatalogueRules(pt) {
    if (!variantRadiosEl) return;

    var m = getMatrix();
    if (!m) return;

    var allowed = m.allowed[normalize(pt.title)];
    if (!allowed) return;

    currentAllowed = allowed;

    Object.keys(allowed).forEach(function (key) {
      var pos = parseInt(key, 10);
      var fieldset = findOptionFieldset(pos);
      if (!fieldset) return;

      var values = allowed[key];
      var needsReselect = false;

      fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var ok = values.indexOf(normalize(radio.value)) !== -1;
        if (setOptionHidden(radio, !ok)) needsReselect = true;
      });

      syncSwatchKingValues(fieldset, values);

      if (needsReselect) reselectFirstVisible(fieldset);
    });
  }

  // Last derived sets, kept so the Swatch King observer can restore the filter after the app
  // rebuilds its controls, without waiting for the debounced pass.
  var currentAllowed = null;

  function restoreCatalogueFilters() {
    if (!currentAllowed || !variantRadiosEl) return;
    Object.keys(currentAllowed).forEach(function (key) {
      var fieldset = findOptionFieldset(parseInt(key, 10));
      if (fieldset) syncSwatchKingValues(fieldset, currentAllowed[key]);
    });
    collapseSingleChoiceGroups();
  }

  /**
   * Find the Swatch King group that stands in for a native fieldset.
   *
   * Matched by value set rather than by label, so a renamed option or a translated label does
   * not break the pairing. Verified on the live store: MARCO renders as a stack of
   * [data-value] swatches, PASPARTÚ and TAMAÑO as ul.swatch-drop-down-list > li.
   */
  function swatchGroupValues(group) {
    var out = [];
    var dropdown = group.querySelectorAll('.swatch-drop-down-list > li');
    if (dropdown.length) {
      Array.prototype.forEach.call(dropdown, function (li) { out.push(normalize(li.textContent)); });
      return out;
    }
    Array.prototype.forEach.call(group.querySelectorAll('[data-value]'), function (el) {
      out.push(normalize(el.dataset.value));
    });
    return out;
  }

  function swatchKingGroupFor(fieldset) {
    var sk = document.querySelector('variant-swatch-king');
    if (!sk) return null;

    var want = Array.prototype.map.call(
      fieldset.querySelectorAll('input[type="radio"]'),
      function (radio) { return normalize(radio.value); }
    );
    if (!want.length) return null;

    var groups = sk.querySelectorAll('.swatch-single');
    for (var i = 0; i < groups.length; i++) {
      var have = swatchGroupValues(groups[i]);
      if (have.length !== want.length) continue;
      var same = have.every(function (v) { return want.indexOf(v) !== -1; });
      if (same) return groups[i];
    }
    return null;
  }

  function syncSwatchKingValues(fieldset, values) {
    var group = swatchKingGroupFor(fieldset);
    if (!group) return;

    var dropdown = group.querySelectorAll('.swatch-drop-down-list > li');
    if (dropdown.length) {
      Array.prototype.forEach.call(dropdown, function (li) {
        li.classList.toggle('tca-compat-hidden', values.indexOf(normalize(li.textContent)) === -1);
      });
      return;
    }

    Array.prototype.forEach.call(group.querySelectorAll('[data-value]'), function (el) {
      var hide = values.indexOf(normalize(el.dataset.value)) === -1;
      el.classList.toggle('tca-compat-hidden', hide);
      var item = el.closest('li');
      if (item) item.classList.toggle('tca-compat-hidden', hide);
    });
  }

  /**
   * A group with fewer than two selectable options is not a choice.
   *
   * Lino admits only "sin paspartú", so the PASPARTÚ group used to render as a title over a
   * single "NO" — noise the customer has to read and cannot act on. Hide the whole group,
   * legend included, and leave the surviving value selected so the form still submits the right
   * variant. Applies uniformly: paspartú, tamaño, vidrio and the print-type switcher itself.
   */
  function collapseSingleChoiceGroups() {
    var fieldsets = document.querySelectorAll('fieldset.product-form__controls, fieldset.tca-fieldset');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;

      var selectable = 0;
      var survivor = null;
      Array.prototype.forEach.call(radios, function (radio) {
        if (radio.classList.contains('tca-compat-hidden')) return;
        selectable++;
        survivor = radio;
      });

      // Glass is the one group that must survive having a single value: it is not a choice, it
      // is a statement about what the customer is buying. Mandatory glass always shows ("Con
      // Vidrio"); declared absence shows too ("Sin Vidrio", Lino), so Papel and Lino never look
      // the same on the page. docs/testimonia-product-rules.md §3.1.
      var stated =
        fs.getAttribute('data-tca-vidrio-estado') === 'obligatorio' ||
        fs.hasAttribute('data-tca-vidrio-declarado');
      var collapse = selectable < 2 && !stated;
      fs.classList.toggle('tca-group-collapsed', collapse);

      if (collapse && survivor && !survivor.checked && !survivor.disabled) {
        survivor.checked = true;
        // Same reason as everywhere else: a group the customer cannot see still has to carry a
        // checked value, or the variant lookup goes out with a hole in it.
        if (fs.hasAttribute('data-option-position')) pendingSelectionChange = true;
      }

      var group = swatchKingGroupFor(fs);
      if (group) group.classList.toggle('tca-group-collapsed', collapse);
    });
  }

  /**
   * Glass availability, derived from the Vidrio sub-product.
   *
   * "Con Vidrio" is offered whenever the Vidrio product stocks an available variant for the
   * size in effect, and hidden otherwise; the group then collapses, because one option is not a
   * choice. Nothing forces glass: the previous matrix carried
   * "Papel Fine Art": { "vidrio": "mandatory" }, a literal with no counterpart in the catalogue,
   * and it was the reason "Sin Vidrio" could not be chosen on Fine Art.
   *
   * This used to call setOptionMuted, which left "Con Vidrio" on screen at 0.35 opacity. That
   * was the right call while glass availability came from a literal that could be wrong; now
   * that it is read off the Vidrio sub-product, an unavailable size has nothing to sell.
   */
  /**
   * Which of the three glass states applies right now.
   *
   * Returns 'obligatorio' | 'opcional' | 'no-disponible'.
   *
   * The rule is declared on the print-type product and arrives in #tca-data as `vidrioRule`; it
   * cannot be derived, because the Vidrio sub-product stocks all six sizes at $0 and therefore
   * answers "available" to everything. See docs/testimonia-product-rules.md §3.
   *
   * With no rule the old behaviour stands — glass offered whenever the Vidrio product has a
   * variant for the size in effect — so a print type whose metafield is not filled in yet keeps
   * working exactly as before.
   */
  // Print type first, product second. A type with no print-type sub-product — papiros — can
  // still declare the rule on itself. docs/testimonia-product-rules.md §3.0.
  function vidrioRule() {
    var pt = data.printTypes[state.printTypeIndex];
    var rule = (pt && pt.vidrioRule) || data.productVidrioRule;
    return rule && rule.modo ? rule : null;
  }

  function vidrioState() {
    var rule = vidrioRule();

    if (!rule) return findVidrioVariant() ? 'opcional' : 'no-disponible';

    if (rule.modo === 'no-disponible') return 'no-disponible';

    // `tallas` narrows any mode to the sizes it lists; outside them there is no glass at all.
    // Omitting it means "at every size", which is how both cuadro print types are declared today.
    // An unknown current size is not evidence of anything, so it never withdraws the option.
    //
    // It applies to `obligatorio` too, not just `opcional`. A piece can be glazed as standard up
    // to a size and unglazed above it — a 110 x 155 sheet of glass is a different object to ship
    // than a 20 x 30 one — and until this the mode ignored the list, so that rule could not be
    // expressed at all. Nothing changes for a rule with no `tallas`.
    var sizes = rule.tallas;
    var fueraDeRango =
      sizes && sizes.length && state.currentSizeCode && sizes.indexOf(state.currentSizeCode) === -1;
    if (fueraDeRango) return 'no-disponible';

    if (rule.modo === 'obligatorio') return 'obligatorio';

    return 'opcional';
  }

  /**
   * Glass, in the three states the spreadsheet actually describes.
   *
   *   obligatorio    the piece always ships glazed. The group stays on screen, stated as
   *                  included, with "Sin Vidrio" removed. Hiding it would make something the
   *                  customer is paying for invisible, and leave a glazed piece and an unglazed
   *                  one looking identical on the page.
   *   opcional       a real choice; both values selectable.
   *   no-disponible  the piece has no glass. "Con Vidrio" is removed and "Sin Vidrio" stays
   *                  selected. When a rule declares it — Lino — the group stays on screen as
   *                  "Sin Vidrio", so the customer can tell a Lino piece from a glazed Papel one
   *                  without guessing why the group vanished. With no rule it is just a size the
   *                  Vidrio sub-product does not stock, and the group collapses as before.
   *
   * The state is written to the fieldset, plus data-tca-vidrio-declarado when a rule decided it,
   * so collapseSingleChoiceGroups() can exempt the stated cases, which would otherwise be hidden
   * for having a single selectable value.
   */
  function applyVidrioRules() {
    if (!vidrioFieldset) return;

    var radioSi = vidrioFieldset.querySelector('input[value="si"]');
    var radioNo = vidrioFieldset.querySelector('input[value="no"]');

    var estado = vidrioState();
    vidrioFieldset.setAttribute('data-tca-vidrio-estado', estado);
    vidrioFieldset.toggleAttribute('data-tca-vidrio-declarado', !!vidrioRule());

    if (estado === 'obligatorio') {
      setOptionHidden(radioNo, true);
      setOptionHidden(radioSi, false);
      if (radioSi && !radioSi.checked) radioSi.checked = true;
      state.vidrioEnabled = true;
      return;
    }

    if (estado === 'no-disponible') {
      setOptionHidden(radioSi, true);
      setOptionHidden(radioNo, false);
      if (radioNo && !radioNo.checked) radioNo.checked = true;
      state.vidrioEnabled = false;
      return;
    }

    setOptionHidden(radioNo, false);
    setOptionHidden(radioSi, false);
  }


  // ── Marco × talla ──────────────────────────────────────────────────────────

  /**
   * Hide the sizes the selected marco does not come in.
   *
   * Two marcos have no XS — Vintage Bambú Imperial and Vintage Perlas — confirmed against the
   * product's full 412 variants. The page offered them anyway, which is a combination the
   * customer can pick and the catalogue does not have.
   *
   * It has to be declared rather than derived: both marcos sit past the 250-variant window the
   * storefront exposes (their groups appear with 15 and 10 of 36 variants), so no group-by over
   * the published variants can tell "has no XS" from "not visible from here". The rule comes from
   * FICHA TIPO PRODUCTOS and is editable in the Theme Editor —
   * docs/testimonia-product-rules.md §4.
   *
   * Matched on the WORDS of the marco name, in any order and any casing, because both have
   * already broken literal matching: the live value is "Vintage Perlas" where an earlier key said
   * "PERLAS VINTAGE", and the store moved to Title Case on 2026-09-01.
   *
   * A rule can be narrowed to the paspartú: "Vintage Negro con paspartú: XS" blocks XS only when
   * a paspartú other than NO is selected. The catalogue's gaps are marco × paspartú → talla, not
   * marco → talla: Vintage Bambú Imperial has S only without paspartú, Vintage Negro has XS only
   * without paspartú. Measured on all 361 active cuadros on 2026-10-06, identical in every one.
   */
  // No trailing \b: without the u flag JS treats Ú as a non-word character, so "PASPARTÚ\b" at
  // the end of the string never matches.
  var CON_PASPARTU = /\s*\bCON PASPART[UÚ](?![A-Z])\s*/;

  function marcoRules() {
    return (data.marcoSizeBlocked || []).map(function (r) {
      var marco = normalize(r.marco);
      var conPaspartu = CON_PASPARTU.test(marco);
      return {
        words: marco.replace(CON_PASPARTU, ' ').split(' ').filter(Boolean),
        sizes: (r.sizes || []).map(function (x) { return normalize(x); }),
        conPaspartu: conPaspartu,
      };
    }).filter(function (r) { return r.words.length && r.sizes.length; });
  }

  // Found by the option name rather than by position, for the same reason as the marco group.
  function paspartuSelected() {
    if (!variantRadiosEl) return null;
    var radios = variantRadiosEl.querySelectorAll('fieldset[data-option-position] input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/^PASPART[UÚ]/.test(normalize(radios[i].name))) return normalize(radios[i].value);
    }
    return null;
  }

  function marcoMatches(value, words) {
    var haystack = normalize(value);
    return words.every(function (w) { return haystack.indexOf(w) !== -1; });
  }

  // The marco group is found by its values, not by option position: it is option 1 on a cuadro
  // and option 2 on a papiro, and a positional lookup would silently filter the wrong control.
  function findMarcoFieldset(rules) {
    if (!variantRadiosEl) return null;
    var fieldsets = variantRadiosEl.querySelectorAll('fieldset[data-option-position]');
    for (var i = 0; i < fieldsets.length; i++) {
      var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < radios.length; j++) {
        for (var k = 0; k < rules.length; k++) {
          if (marcoMatches(radios[j].value, rules[k].words)) return fieldsets[i];
        }
      }
    }
    return null;
  }

  /**
   * Give back the sizes the marco rule took away on the previous pass.
   *
   * Nothing else restores them: the print-type rules do not cover the size group, so an XS hidden
   * for Vintage Perlas stayed hidden after switching back to Mañío, and the smallest Mañío could
   * not be bought without reloading the page (seen live 2026-10-06). Runs before the print-type
   * rules, so a size those rules rule out is hidden again by them, not by this.
   */
  function restoreMarcoHiddenSizes() {
    if (!variantRadiosEl) return;
    var radios = variantRadiosEl.querySelectorAll('input[type="radio"][data-tca-marco-hidden]');
    Array.prototype.forEach.call(radios, function (radio) {
      radio.removeAttribute('data-tca-marco-hidden');
      setOptionHidden(radio, false);
    });
    var sizeFieldset = findOptionFieldset(3);
    if (radios.length && sizeFieldset) syncSwatchKingSizeCodes(sizeFieldset);
  }

  function applyMarcoSizeRules() {
    var rules = marcoRules();
    if (!rules.length) return;

    var marcoFieldset = findMarcoFieldset(rules);
    if (!marcoFieldset) return;

    var checkedMarco = marcoFieldset.querySelector('input[type="radio"]:checked');
    if (!checkedMarco) return;

    var paspartu = paspartuSelected();
    var conPaspartu = !!paspartu && paspartu !== 'NO';

    var blocked = [];
    rules.forEach(function (r) {
      if (r.conPaspartu && !conPaspartu) return;
      if (marcoMatches(checkedMarco.value, r.words)) blocked = blocked.concat(r.sizes);
    });
    if (!blocked.length) return;

    var sizeFieldset = findOptionFieldset(3);
    if (!sizeFieldset) return;

    var radios = sizeFieldset.querySelectorAll('input[type="radio"]');
    var invalidated = false;
    Array.prototype.forEach.call(radios, function (radio) {
      if (radio.classList.contains('tca-compat-hidden')) return; // already ruled out by print type
      var code = extractSizeCode(radio.value);
      if (code && blocked.indexOf(normalize(code)) !== -1) {
        radio.setAttribute('data-tca-marco-hidden', '');
        if (setOptionHidden(radio, true)) invalidated = true;
      }
    });

    if (invalidated) reselectFirstVisible(sizeFieldset);

    syncSwatchKingSizeCodes(sizeFieldset);
  }

  // Mirror onto the app's dropdown, which is the list the customer actually reads.
  function syncSwatchKingSizeCodes(sizeFieldset) {
    var allowed = [];
    Array.prototype.forEach.call(
      sizeFieldset.querySelectorAll('input[type="radio"]'),
      function (radio) { if (!radio.classList.contains('tca-compat-hidden')) allowed.push(normalize(radio.value)); }
    );
    syncSwatchKingValues(sizeFieldset, allowed);
  }

  function findOptionFieldset(position) {
    var fs = variantRadiosEl.querySelector('fieldset[data-option-position="' + position + '"]');
    if (fs) return fs;
    var all = variantRadiosEl.querySelectorAll('fieldset.product-form__controls:not(.tca-fieldset)');
    return all[position - 1] || null;
  }

  // ── Update price overlay ───────────────────────────────────────────────────

  function updateAll() {
    readCurrentSizeFromDOM();
    updatePriceOverlay();
  }

  function updatePriceOverlay() {
    if (!nativePriceEl) return;

    var ptVariant = findPrintTypeVariant();
    var vidrioVariant = state.vidrioEnabled ? findVidrioVariant() : null;
    var addonTotal = 0;
    if (ptVariant) addonTotal += ptVariant.price;
    if (vidrioVariant) addonTotal += vidrioVariant.price;

    var addonSpan = document.getElementById('tca-addon-price');

    if (addonTotal > 0) {
      if (!addonSpan) {
        addonSpan = document.createElement('div');
        addonSpan.id = 'tca-addon-price';
        var priceBlock = nativePriceEl.closest('.price') || nativePriceEl.closest('.price-wrapper');
        if (priceBlock) {
          priceBlock.appendChild(addonSpan);
        } else {
          nativePriceEl.parentNode.appendChild(addonSpan);
        }
      }
      addonSpan.textContent = '+ ' + formatMoney(addonTotal) + ' (impresión' + (vidrioVariant ? ' + vidrio' : '') + ')';
    } else if (addonSpan) {
      addonSpan.textContent = '';
    }
  }

  // ── Variant matching ───────────────────────────────────────────────────────

  function findPrintTypeVariant() {
    if (!data.printTypes.length) return null;
    var pt = data.printTypes[state.printTypeIndex];
    if (!pt) return null;
    var size = state.currentSizeCode;
    if (!size) return null;

    for (var i = 0; i < pt.variants.length; i++) {
      var v = pt.variants[i];
      if (v.option1 === 'Cuadro' && extractSizeCode(v.option2) === size && v.available) {
        return v;
      }
    }
    return null;
  }

  function findVidrioVariant() {
    if (!data.vidrio) return null;
    var size = state.currentSizeCode;
    if (!size) return null;

    for (var i = 0; i < data.vidrio.variants.length; i++) {
      var v = data.vidrio.variants[i];
      if (extractSizeCode(v.option1) === size && v.available) return v;
    }
    return null;
  }

  // ── Cart intercept ─────────────────────────────────────────────────────────

  function interceptCartSubmit() {
    if (!nativeAddToCartForm) return;

    nativeAddToCartForm.addEventListener('submit', function (e) {
      if (!data.printTypes.length && !data.vidrio) return;

      e.preventDefault();
      e.stopPropagation();

      var mainVariantInput = nativeAddToCartForm.querySelector('input[name="id"]');
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
      if (!mainVariantId) return;

      var ptVariant = findPrintTypeVariant();
      var vidrioVariant = state.vidrioEnabled ? findVidrioVariant() : null;
      var pt = data.printTypes[state.printTypeIndex];

      var bundleId = 'cuadro-' + Date.now();
      var items = [];

      items.push({
        id: parseInt(mainVariantId, 10),
        quantity: 1,
        properties: {
          'Tipo de Impresión': pt ? pt.title : '',
          'Vidrio': state.vidrioEnabled ? 'Sí' : 'No',
          '_bundle_id': bundleId,
        },
      });

      if (ptVariant) {
        items.push({
          id: ptVariant.id,
          quantity: 1,
          properties: {
            '_bundle': 'Cuadro',
            '_bundle_id': bundleId,
            '_role': 'Impresión',
          },
        });
      }

      if (vidrioVariant) {
        items.push({
          id: vidrioVariant.id,
          quantity: 1,
          properties: {
            '_bundle': 'Cuadro',
            '_bundle_id': bundleId,
            '_role': 'Vidrio',
          },
        });
      }

      if (nativeAddToCartBtn) {
        nativeAddToCartBtn.setAttribute('aria-disabled', 'true');
        nativeAddToCartBtn.classList.add('loading');
      }

      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.json(); })
        .then(function (responseData) {
          if (nativeAddToCartBtn) {
            nativeAddToCartBtn.removeAttribute('aria-disabled');
            nativeAddToCartBtn.classList.remove('loading');
          }

          var cartDrawer = document.querySelector('cart-drawer');
          var cartNotification = document.querySelector('cart-notification');

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            fetch(cartUrl.replace('add.js', '') + '?sections=cart-drawer,cart-icon-bubble')
              .then(function (r) { return r.json(); })
              .then(function (sections) { cartDrawer.renderContents({ sections: sections }); })
              .catch(function () { window.location.href = '/cart'; });
          } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
            cartNotification.renderContents(responseData);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[TCA] Cart error:', err);
          if (nativeAddToCartBtn) {
            nativeAddToCartBtn.removeAttribute('aria-disabled');
            nativeAddToCartBtn.classList.remove('loading');
          }
        });
    });
  }

  // ── Paspartú: the final size does not change ───────────────────────────────
  //
  // Post-sale complaint, repeated: customers read the paspartú as an extra border added around
  // the size they picked, and expect a bigger piece. It is the other way round — the paspartú
  // sits inside the chosen size. Two small touches say so where the choice is made:
  //   - a one-line note under the PASPARTÚ control: "*INCLUIDO EN EL TAMAÑO FINAL - NO SUMA CM
  //     EXTRA". It stays whatever is selected, and CSS hides it while the dropdown is open so it
  //     never sits under the list.
  //   - the TAMAÑO title reads "TAMAÑO FINAL CUADRO". Display only: the option name, and with it
  //     the cart line and every rule that reads `name`, is untouched.
  //
  // Independent of init(): it needs no #tca-data, only a PASPARTÚ option, so it also covers
  // templates where the addon rules have nothing to do.

  var PASPARTU_NOTE_CLASS = 'testimonia-paspartu-note';
  var PASPARTU_NOTE_TEXT = '*Incluido en el tamaño final - No suma cm extra';
  var SIZE_TITLE_TEXT = 'Tamaño final cuadro';

  function swatchGroupByName(pattern) {
    var groups = document.querySelectorAll('variant-swatch-king .swatch-single');
    for (var i = 0; i < groups.length; i++) {
      var box = groups[i].querySelector('legend input[name]');
      if (box && pattern.test(box.getAttribute('name'))) return groups[i];
    }
    return null;
  }

  function nativeFieldsetByLegend(pattern) {
    var legends = document.querySelectorAll('fieldset[data-option-position] legend');
    for (var i = 0; i < legends.length; i++) {
      if (pattern.test(legends[i].textContent)) return legends[i].closest('fieldset');
    }
    return null;
  }

  function renderPaspartuNote() {
    var group = swatchGroupByName(/PASPART/i);
    var host = group ? group.querySelector('fieldset') || group : nativeFieldsetByLegend(/PASPART/i);
    if (host && !host.querySelector('.' + PASPARTU_NOTE_CLASS)) {
      var note = document.createElement('p');
      note.className = PASPARTU_NOTE_CLASS;
      note.textContent = PASPARTU_NOTE_TEXT;
      host.appendChild(note);
    }

    // Swatch King's title is the option name as a bare text node before the separator span;
    // only that node is rewritten.
    var sizeGroup = swatchGroupByName(/^TAMA/i);
    var title = sizeGroup && sizeGroup.querySelector('legend [id^="option"]');
    var node = title && title.firstChild;
    if (node && node.nodeType === 3 && /^\s*TAMA[ÑN]O\s*$/i.test(node.nodeValue)) {
      node.nodeValue = SIZE_TITLE_TEXT.toUpperCase();
    }
  }

  function initPaspartuNote() {
    var queued = null;
    var schedule = function () {
      clearTimeout(queued);
      queued = setTimeout(renderPaspartuNote, 150);
    };

    // Swatch King re-renders its groups on a variant change, so the note and the title are
    // re-asserted on every signal rather than set once.
    document.addEventListener('change', schedule);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-swatch-king')) schedule();
    });
    document.addEventListener('variant:change', schedule);

    // Swatch King renders after us; same settle window as init().
    var settle = 0;
    var settleTimer = setInterval(function () {
      renderPaspartuNote();
      if (++settle >= 6) clearInterval(settleTimer);
    }, 500);
    renderPaspartuNote();
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 100);
      setTimeout(initPaspartuNote, 100);
    });
  } else {
    setTimeout(init, 100);
    setTimeout(initPaspartuNote, 100);
  }
})();
